export const TrlNbsp = () => {
  return <>&nbsp;</>;
};
